import React from 'react';
import './LoadingOverlay.less';

interface LoadingOverlayProps {
  message?: string;
  isVisible?: boolean;
  overlay?: boolean; // true = full overlay, false = inline
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  message = "Loading...",
  isVisible = true,
  overlay = true
}) => {
  if (!isVisible) return null;

  return (
    <div className={`loading-overlay ${overlay ? 'loading-overlay--fullscreen' : 'loading-overlay--inline'}`}>
      <div className="loading-overlay__content">
        {/* Animated spinner */}
        <div className="loading-overlay__spinner">
          <div className="loading-overlay__spinner-ring"></div>
          <div className="loading-overlay__spinner-ring"></div>
          <div className="loading-overlay__spinner-ring"></div>
        </div>
        
        {/* Dynamic message */}
        <div className="loading-overlay__message">
          {message}
          <span className="loading-overlay__dots">
            <span className="dot dot--1">.</span>
            <span className="dot dot--2">.</span>
            <span className="dot dot--3">.</span>
          </span>
        </div>
        
        {/* Subtitle */}
        <div className="loading-overlay__subtitle">
          Please wait while we fetch the latest data
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
